import * as React from 'react';
import { Box, Typography, Divider, Buttonz,InputBase,Button } from '@mui/material';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import prodOne from "../assets/prodOne.png"
import { useSelector, useDispatch } from 'react-redux';
import { updateSideBar, updateCartSideBar } from '../redux/active_bar';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import SideBarList from './list';
import CancelIcon from '@mui/icons-material/Cancel';
import { useState } from 'react';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import { useMediaQuery } from 'react-responsive';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { updateCart } from '../redux/products';
import axios from 'axios';
import CustomAxios from '../utils/CustomAxios';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { updateSnackBarMessage, updateSnackBarSeverity, updateSnackBarOpen } from "../redux/snackbar";
import { useEffect } from 'react';
import MessageBar from '../modules/messageBar';
import { updateIsProfileReloaded, updateMemberResponse, updateUserData,updateSigninForm } from '../redux/user_reducer';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { TranslateText } from "../utils/googletranslator";
import { CalculateProductPrice } from '../utils/price';
const Cart = () => {
    const dispatch = useDispatch()
    let user_accDetails = useSelector(state => state.user.member_response.account)
    const [referralCode,setReferralCode]=useState("")
    const language=useSelector(state=>state.user.language)
    const [errors,setErrors]=useState({})
    const id=useSelector(state=>state.user.id) 
    // console.log(user_accDetails)
    const [state, setState] = React.useState({
        right: false,
    });
    const [total, setTotal] = useState()
    // const [item, setItem] = useState()
    const cart = useSelector(state => state.product.cart)
    const cartSidebar = useSelector(state => state.sideBar.cartSidebar)
    const authtoken=localStorage.getItem("authtoken")
    const member=useSelector(state=>state.user.member)
    const navigate=useNavigate()
    React.useEffect(() => {
        // // console.log("toggle bar", cartSidebar)
        // toggleDrawer('right',cartSidebar)
        setState({ ...state, ['right']: cartSidebar })
    }, [cartSidebar])

    useEffect(() => {
        
            let totalPrice = 0;
            cart.forEach(item => {
                // const price = authtoken? (parseFloat(item.product?.selling_price) + Math.round(parseFloat(item.product?.selling_price) * (parseFloat(item.product?.tax)/100)  )).toFixed(2): (parseFloat(item.product?.price) + Math.round(item.product?.price * (item.product?.tax/100) )) .toFixed(2)
                const price = CalculateProductPrice({authtoken:authtoken,member:member,item:item})
                totalPrice += parseFloat(price) * item.quantity;
            });
        setTotal(totalPrice.toFixed(2));
        // calculateTotal();
    }, [cart, authtoken,member]);
// console.log(total)
    const toggleDrawer = (anchor, open) => (event) => {
        // // console.log(anchor)
        setReferralCode("")
        setErrors({})
        if (
            // cartSidebar
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }
        if (!open) {
            dispatch(updateCartSideBar(false))
        }
        setState({ ...state, [anchor]: open });
    };
    const isMobile = useMediaQuery({ maxWidth: 600 });
    const clearCart = (item) => {
        const prevCart = [...cart]
        // // console.log()
        const newCart = prevCart.filter(ct => ct.product?.id !== item.product?.id)
        if (authtoken){
            CustomAxios.delete(`cart/${item.id}/`)
        }

        // // console.log(newCart)/
        dispatch(updateCart(newCart))
        localStorage.setItem("cart", JSON.stringify(newCart))
        // // console.log( localStorage.setItem("cart",newCart))
        // // console.log()
    }
    const updateQuantity = async (object, condition) => {
       
        let productUpdate=false
        let products = [...cart]
        let notUpdated=false
        // console.log(object)
        const newCart = products.map(item => {
            // console.log("????????????????????????/not update available",object.product.available_quantity,item.quantity,item.product?.id == object.product.id&&condition)
            if (object.product.available_quantity<=item.quantity&&item.product?.id == object.product.id&&condition ){
                // console.log("????????????????????????/not update available",object.product.available_quantity<=item.quantity&&item.product?.id == object.product.id&&condition)
                notUpdated=true
            }

            // console.log("??????????????????not updated",notUpdated)
            if (condition && item.product?.id == object.product.id && item.product.inventry_details?.available_quantity>item.quantity&&!notUpdated ) {
                let updated = { ...item }
                productUpdate=true
                updated.quantity += 1
                // // console.log("if condition")
                if (item.id) {
                    CustomAxios.patch(`cart/${item.id}/`, {
                        quantity: updated.quantity,
                        // totalprice:updated.quantity*(parseFloat(updated.price)+ Math.round(updated?.price * (updated.product?.tax/100) ) )
                        totalprice:updated.quantity * CalculateProductPrice({authtoken:authtoken,member:member,item:item,lineStrike:false})
                    })
                    return updated
                }
                else {

                    return updated

                }

            }
            else if (!condition && item.product?.id == object.product?.id) {
                productUpdate=true
                let updated = { ...item }
                updated.quantity -= 1

                if (item.id && updated.quantity >= 1) {
                    // console.log(updated.quantity)
                    CustomAxios.patch(`cart/${item.id}/`, {
                        quantity: updated.quantity,
                        // totalprice:updated.quantity*(parseFloat(updated.price)+ Math.round(updated?.price * (updated.product?.tax/100) ) )
                        totalprice:updated.quantity*CalculateProductPrice({authtoken:authtoken,member:member,item:item,lineStrike:false})
                    })
                    return updated
                }
                else if (item.id && updated.quantity < 1) {
                    CustomAxios.delete(`cart/${item.id}/`)
                    return updated
                }
                else {

                    return updated

                }


            }
            else if (item.product?.id == object.id){
                // console.log( item.product.inventry_details.available_quantity, item.quantity)
                if(condition && item.product.inventry_details.available_quantity==item.quantity) {
                    productUpdate=false
                } 
                else{
                    productUpdate=true
                }
                return item
               

            }
            else{
                return item
            }

        })
        if (productUpdate &&!notUpdated){
            dispatch(updateCart(newCart.filter((item) => !item?.quantity < 1)))
            localStorage.setItem("cart", JSON.stringify(newCart.filter((item) => !item?.quantity < 1)))
            // console.log("clipboard open")
            dispatch(updateSnackBarMessage("Successfully Updated the Cart!"))
            dispatch(updateSnackBarSeverity("success"))
    
            dispatch(updateSnackBarOpen(true))
        }
        else{
            dispatch(updateCart(newCart.filter((item) => !item?.quantity < 1)))
            localStorage.setItem("cart", JSON.stringify(newCart.filter((item) => !item?.quantity < 1)))
            // console.log("clipboard open",notUpdated)
            if (!notUpdated){
                dispatch(updateSnackBarMessage(`You are exceeding the available stock!. You can add only ${object.product.inventry_details?.available_quantity} quantity to your cart.`))
            }
            else{
                dispatch(updateSnackBarMessage(`We are Restocking.You can purchase only ${object.product.available_quantity}`))

            }
            
            dispatch(updateSnackBarSeverity("error"))
    
            dispatch(updateSnackBarOpen(true))
        }
    }
    const updateReferral=()=>{
        const payload={
          referral:referralCode,
          id:id
        }
        CustomAxios.post ("update-eferral/",payload).then(({data})=>{
            if(data.message=="Successfully Updated!"){
                // console.log(data.user)
      
                dispatch(updateMemberResponse(data.user))

                dispatch(updateSnackBarMessage("Sponsor Updated Successfully"))
            dispatch(updateSnackBarSeverity("success"))
          
          dispatch(updateSnackBarOpen(true))
          dispatch(updateIsProfileReloaded(true))
        //   dispatch(updateCartSideBar(false))
        // window.location.reload();
            }
            else{
                setErrors({referralCode:data.message})
            }
        }
        )
      }

    // React.useEffect(() => {
    //     const total = cart.reduce((a, b) => a + parseInt(authtoken?b.product?.selling_price:b.product?.price * b.quantity), 0)

    //     setTotal(parseFloat(total).toFixed(2))
    // }, [cart])

    const checkOut=()=>{
        dispatch(updateCartSideBar(false))
        // if(authtoken){

            navigate("/checkout")
        // }
        // else{
        //     localStorage.setItem("redirect","/checkout")
        //     navigate("/login")
        // }
    }
    return (
        <div>

            <React.Fragment key={'right'}>
                {/* <Button onClick={toggleDrawer('right', true)} sx={{zIndex:"10"}}>{'right'}</Button> */}
                <SwipeableDrawer
                    anchor={"right"}
                    open={state["right"]}
                    onClose={toggleDrawer("right", false)}
                    onOpen={toggleDrawer("right", true)}
                    sx={{marginRight:0}}
                >
                    <MessageBar/>

                    <Box sx={{ width: {xs :cart?.length <= 0?"300px":"100%",sm : "448px"},zIndex:"20" }}>


                        <Box sx={{ padding: "16px 24px", display: "flex", justifyContent: "space-between", alignItems: "center",height:"61px",alignItems:"center" }}>

                            <Box sx={{ display: "flex", gap: "12px" }}><ShoppingCartOutlinedIcon sx={{ color: "primary.light",height:"24px",width:"22px", fontSize: "28px", fontWeight: "600" }} />  <TranslateText sx={{ color: "primary.light", fontSize: "16px", fontWeight: "600",display:"flex",alignItems:"flex-end" }} > {cart?.length > 0 && cart?.length} Item</TranslateText></Box>



                            {/* <IconButton sx={{ backgroundColor: 'grey.200',width:"28px",height:"28px","&:hover":{bgcolor:"primary.light",color:"#FFF"}}} onClick={() => dispatch(updateCartSideBar(false))} > */}
                                <CloseIcon onClick={() => dispatch(updateCartSideBar(false))} sx={{ backgroundColor: 'grey.200',width:"28px",height:"28px",color:"grey.500",borderRadius:"50px",padding:"5px","&:hover":{bgcolor:"primary.light",color:"#fff",cursor:"pointer"},transition:".3s ease-in-out" }} />
                                {/* </IconButton> */}

                        </Box>
                        <Divider />
                        {cart?.length <= 0 ? <Box sx={{ display: 'flex', alignItems: "center", width: "100%", justifyContent: "center", height: "calc(100vh - 60px) " }}>
                            <ShoppingBagIcon sx={{ color: "primary.light", opacity: "0.5", fontSize: "150px" }} />
                            { user_accDetails?.referred_by_id == 68&& <Box sx={{display:"flex",alignItems:"center",position:"fixed",bottom:"80px",bgcolor:"rgba(255,255,255,0.7)",maxWidth:"448px",padding:"20px 0px",justifyContent:"center",width:"100%",backdropFilter: "blur(40px)",}}>
                            <Box sx={{ width: "100%", maxWidth: "289px", alignSelf: "center" ,zIndex:5}}>
                                <TranslateText sx={{ fontSize: "14px", fontWeight: "700", textAlign: "center",color: "primary.light", }} >Enter Sponsor Referral Code</TranslateText>
                                <TranslateText sx={{ fontSize: "12px", fontWeight: "400", textAlign: "center" }} >Unlock exclusive benefits by entering a valid referral code. Activate your membership and make your first purchase with MAYI IQ. Plus, when you refer others with your username / referral code, you'll earn commissions on their purchases!</TranslateText>
                                <Box sx={{display:"flex",gap:"3px",marginTop:"16px"}}>                            
                                    
                                        {/* <TranslateText sx={{ fontWeight: 400, fontSize: "12px",lineHeight:"16px"}} color="error">Invalid code. Please enter the valid code.</TranslateText> */}
                                        <InputBase value={referralCode} onChange={(e) => setReferralCode(e.target.value.replace(" ", ""))} placeholder="Referral Code/Username" sx={{ border: "1px solid", borderColor: "grey.400", width: "100%", borderRadius: "5px", height: "48px", fontSize: "16px", padding: "14px", color: "grey.700" }}></InputBase>
                                        

                                    
                                        <Button disabled={!referralCode} variant="contained" sx={{ bgcolor: "primary.light", color: "primary.contrastText", height: "48px", padding:"8px 12px", textTransform: "none",minWidth:language=='ta'?"125px":"100px",}} onClick={updateReferral} ><TranslateText>Submit</TranslateText></Button>
                                    
                                        {/* <Button sx={{bgcolor:"transparent",border:"none",outline:"none",textTransform:"none"}}><TranslateText sx={{fontWeight: 400, fontSize: "16px",lineHeight:"24px",}} color={resend&& time==0 ?"primary":"#BFC7D4"}>Resend OTP</TranslateText></Button> */}
                                    
                                </Box>
                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px", lineHeight: "16px", margin: "5px 0px" }} color="error">{errors.referralCode}</TranslateText>

                                </Box> 
                                    </Box>}


                        </Box> :
                            <Box sx={{ height: "calc(100vh - 60px) ", }}>

                                {cart?.length > 0 && cart.map((item,item_idx) => {

                                    {/* <ShoppingBagIcon sx={{ color: "primary.light", opacity: "0.7", fontSize: "150px" }} /> */ }
                                    return <Box key={item_idx} sx={{ display: "flex", padding:  "16px 24px" , alignItems: "center", justifyContent: "space-between",borderBottom:"1px solid rgb(229, 228, 226)"  }} >
                                        <Box sx={{ display: "flex", alignItems: "start",gap:"15px",flexGrow:2 }}>
                                            
                                            <Box component='img' sx={{ width: "100px", height: "100px" }} src={ item?.product?.cover_details?.original || prodOne} />
                                            <Box sx={{ display: "flex", flexDirection: "column", flexGrow:2 }}>
                                                <TranslateText sx={{ fontSize: "14px", fontWeight: "600" }}> {item.product?.name}</TranslateText>
                                                <TranslateText sx={{ fontSize: "8px", fontWeight: "400", color: "grey.500", displa: "flex", alignItems: "center", justifyContent: "center",fontSize:"12px" }}> {item.quantity}<CloseIcon sx={{ fontSize: "14px", textAlign: "center" }} />{item.product?.unit}</TranslateText>
                                                <Box sx={{display:"flex",justifyContent:"space-between",flexGrow:2 }}>
                                                <Box sx={{marginTop:"8px",marginBottom:"4px" }}>
                                                        <Typography sx={{ fontSize: "16px", color: "primary.light", fontWeight: "600"}}> <CurrencyRupeeIcon sx={{fontSize:"14px",fontWeight: 600}}/>{
                                                        CalculateProductPrice({authtoken:authtoken,member:member,item:item,lineStrike:false})
                                                    
                                                        }</Typography>
                                                        {Number(item.product?.price) > 0 && Number(item.product?.selling_price) < Number(item.product?.price) && (
                                                         <div style={{ display: "flex", alignItems: "center" }}>
                                                        {/* {authtoken?  */}
                                                        <Typography sx={{ fontSize: "12px", fontWeight: "400", color: "#6F7883",}} >MRP:</Typography>
                                                        <Typography sx={{ fontSize: "12px", fontWeight: "400", color: "#6F7883", textDecoration: "line-through" }}><CurrencyRupeeIcon sx={{ fontSize: "12px", fontWeight: "400", color: "#6F7883", marginTop: "-1px" }}/>{
                                                        CalculateProductPrice({authtoken:authtoken,member:member,item:item,lineStrike:true})
                                                    
                                                        }</Typography>
                                                        </div>
                                                        )}
                                                    </Box>  
                                                <Typography sx={{display:"flex",alignItems:"center",fontSize:"16px",fontWeight:"600"}}><CurrencyRupeeIcon sx={{fontSize:"16px",fontWeight:"600"}}/>{
                                                   parseFloat(item.quantity* CalculateProductPrice({authtoken:authtoken,member:member,item:item,lineStrike:false})).toFixed(2)
                                                // parseFloat(item.quantity * (authtoken ?  parseFloat(item.product?.selling_price) + Math.round(parseFloat(item.product?.selling_price) * (parseFloat(item.product?.tax)/100) ) : parseFloat(item.product?.price) + Math.round(item.product?.price * item.product?.tax/100))).toFixed(2)
                                                }</Typography>
                                                    </Box>
                                                    { item.product?.inventry_details?.available_quantity>0 ?
                                                <Box sx={{ display: "flex", flexDirection: 'row', gap: "4px", bgcolor: "grey.100", padding: "4px 12px", borderTopRightRadius: "20px", borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px", borderBottomRightRadius: "20px", justifyContent: "space-between", alignItems: "center",maxWidth:"90px"}}>

                                                
                                                <Typography onClick={() => updateQuantity(item, false)} sx={{ fontSize: "14px",fontWeight:"400",  cursor: "pointer" }}>
                                                    -
                                                </Typography>
                                                <Typography sx={{ fontSize: "14px",fontWeight:"400",  }}>
                                                    {item.quantity}
                                                </Typography>
                                                <Typography onClick={() => updateQuantity(item, true)} sx={{ fontSize: "14px",fontWeight:"400", cursor: "pointer" }}>
                                                    +
                                                </Typography>
                                                
                                            </Box>:<Box><TranslateText> Out Of Stock</TranslateText></Box>}
                                            </Box>
                                            
                                        </Box>
                                        

                                            
                                            <CloseIcon onClick={()=>clearCart(item)} sx={{alignSelf:"start", width:"28px",height:"28px",color:"grey.500",borderRadius:"50px",padding:"5px","&:hover":{bgcolor:"grey.200",color:"error.dark",cursor:"pointer"},transition:".3s ease-in-out" }} />

                                        

                                    </Box>




                                })}                  
                        <Box sx={{ display: "flex", alignItems: 'center', justifyContent: "center", width: "100%" ,paddingTop:"100px"}}>
                       { user_accDetails?.referred_by_id == 68&& <Box sx={{display:"flex",alignItems:"center",position:"fixed",bottom:"80px",bgcolor:"rgba(255,255,255,0.7)",maxWidth:"448px",padding:"20px 0px",justifyContent:"center",width:"100%",backdropFilter: "blur(40px)",}}>

                                <Box sx={{ width: "100%", maxWidth: "289px", alignSelf: "center" ,zIndex:5}}>
                                <TranslateText sx={{ fontSize: "14px", fontWeight: "700", textAlign: "center",color: "primary.light", }} >Enter Sponsor Referral Code</TranslateText>
                                <TranslateText sx={{ fontSize: "12px", fontWeight: "400", textAlign: "center" }} >Unlock exclusive benefits by entering a valid referral code. Activate your membership and make your first purchase with MAYI IQ. Plus, when you refer others with your username / referral code, you'll earn commissions on their purchases!</TranslateText>
                                <Box sx={{display:"flex",gap:"3px",marginTop:"16px"}}>
                                
                                        {/* <TranslateText sx={{ fontWeight: 400, fontSize: "12px",lineHeight:"16px"}} color="error">Invalid code. Please enter the valid code.</TranslateText> */}
                                        <InputBase value={referralCode} onChange={(e) => setReferralCode(e.target.value.replace(" ", ""))} placeholder="Referral Code/Username" sx={{ border: "1px solid", borderColor: "grey.400", width: "100%", borderRadius: "5px", height: "48px", fontSize: "16px", padding: "14px", color: "grey.700" }}></InputBase>
                                        

                                    
                                        <Button disabled={!referralCode} variant="contained" sx={{ bgcolor: "primary.light", color: "primary.contrastText", height: "48px",padding:"8px 12px", textTransform: "none" ,minWidth:"125px"}} onClick={updateReferral} ><TranslateText>Submit</TranslateText></Button>
                                    
                                        {/* <Button sx={{bgcolor:"transparent",border:"none",outline:"none",textTransform:"none"}}><TranslateText sx={{fontWeight: 400, fontSize: "16px",lineHeight:"24px",}} color={resend&& time==0 ?"primary":"#BFC7D4"}>Resend OTP</TranslateText></Button> */}
                                    
                                </Box>
                                <TranslateText sx={{ fontWeight: 400, fontSize: "12px", lineHeight: "16px", margin: "5px 0px" }} color="error">{errors.referralCode}</TranslateText>

                                </Box> 
                                </Box>}
                            
        
                                    {/* {
                                        user_accDetails?.kyc_status? */}

                                    <Box sx={{ position: "fixed", bottom: "20px",cursor: user_accDetails?.referred_by_id == 68 ? "not-allowed " : "pointer", width: { xs: "80%", sm: "85%" }, maxWidth: { xs: "300px", sm: "400px" } }} onClick={() => { if (user_accDetails?.referred_by_id !== 68) { checkOut() } }}>
                                        <Box sx={{ display: "flex", alignItems: 'center', justifyContent: "space-between", background:"linear-gradient(45deg, #00C2FF 10%, #00E3AF 90%)", height: "56px", borderRadius: "28px", padding: "16px 4px 16px 24px" }}>


                                            <TranslateText sx={{ color: "primary.contrastText", fontWeight: "600", fontSize: "14px" }}>
                                                Checkout
                                            </TranslateText>
                                            <Box sx={{ bgcolor: "primary.contrastText", borderRadius: "50px", height: "50px", padding: "0px 20px", display: "flex", alignItems: "center" }}>
                                                <Typography sx={{ color:"#000", fontWeight: 600, fontSize: "14px" }}>
                                                    <CurrencyRupeeIcon sx={{ fontWeight: 600, fontSize: "14px" }} />{total}
                                                </Typography>

                                            </Box>
                                        </Box>

                                    </Box>
                                    {/* :
                                        <Button variant='contained' color='error' onClick={()=>{dispatch(updateCartSideBar(false));navigate('/profile/?scrollto=kyc')}} sx={{ position: "fixed", bottom: "20px",width:{xs:"80%", sm:"85%"},maxWidth:{xs:"300px",sm:"400px"} }}>Complete KYC</Button>
                                     }   */}
                                </Box>
                            </Box>}

                    </Box>


                </SwipeableDrawer>
            </React.Fragment>

        </div>
    );
}
export default Cart